import React, { useState, useEffect } from "react";
import { Box, Typography, Pagination, Divider } from "@mui/material";
import Grid from "@mui/material/Grid";
import InputControl from "../../Components/Common/TextField/TextField";
import CustomButton from "../../Components/Button/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { V_DeleteAdminPermission, V_GetAdminPermission, V_GetAllCountries } from "../../Reducers/dcoi";
import Spinner from "../../Components/Common/Spinner/Spinner";
import ConfirmationModel from "../../Components/Common/DeleteModel/DeleteModel";
import "../VcoiSiteContent/VcoiManageAdminPermission.css"
function VcoiManageAdminPermission() {

  const disptach = useDispatch()
  const { V_AdminPermissionList, V_countriesList, inProgress } = useSelector(
    (state) => state.dcoi
  );


  useEffect(() => {
    disptach(V_GetAllCountries());
    disptach(V_GetAdminPermission());
  }, [])

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const navigate = useNavigate();
  const [selectedRow, setSelectedRows] = useState();
  const [model, setModel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState(V_AdminPermissionList?.AdminGroups);
  const itemsPerPage = 20;

  const handleSearchChange = (e) => {
    if (e !== undefined) {
      setSearchQuery(e);
    }
  };

  useEffect(() => {
    setFilteredItems(V_AdminPermissionList?.AdminGroups); // Initialize with full data
  }, [V_AdminPermissionList]);

  const handleSearchClick = () => {
    const filteredData = V_AdminPermissionList?.AdminGroups?.map((item) => {
      const matchesGroup = item.EntityAdminGroup?.toLowerCase()?.includes(searchQuery?.toLowerCase());

      // Filter entities that match the search query (only if not matching the group)
      const filteredEntities = Array.isArray(item.Entities)
        ? item.Entities?.filter(entity =>
          entity.Entity?.toLowerCase()?.includes(searchQuery?.toLowerCase())
        )
        : item.Entities?.toLowerCase()?.includes(searchQuery?.toLowerCase())
          ? [item.Entities] // Convert to array if single entity matches
          : [];

      // If EntityAdminGroup matches, return all entities
      if (matchesGroup) {
        return { ...item };
      }

      // If only EntityList matches, return filtered entities
      if (filteredEntities?.length > 0) {
        return { ...item, EntityList: filteredEntities };
      }

      return null; // Exclude items with no matching data
    }).filter(Boolean); // Remove null values

    setFilteredItems(filteredData);
    setCurrentPage(1);
  };



  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems?.slice(indexOfFirstItem, indexOfLastItem);


  const handleDelete = (e) => {
    setModel(!model)
    setSelectedRows(e)
  }

  const SucessDelete = () => {
    setModel(!model);
    disptach(V_DeleteAdminPermission({ id: selectedRow?.EntityAdminGroupId })).then((res) => {
      if (res.payload.status === 200) {
        disptach(V_GetAllCountries());
        disptach(V_GetAdminPermission());
      }
    })
  }


  return (
    <>
      <ConfirmationModel open={model} handleOpen={() => setModel(!model)} SucessDelete={SucessDelete} />
      <div className="headerNavigation">
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
          List of Admin Permission
        </Typography>
        <div></div>
      </div>
      <Box className="boxAlignment">
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={8} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <InputControl
                  placeholder="Search By Entity Admin Group & Entity.."
                  value={searchQuery}            // Bind value to searchQuery state
                  onChange={handleSearchChange}   // Pass the event to handleSearchChange
                />
              </Box>
              <Button
                sx={{ backgroundColor: "#212129", color: "white", padding: "8px", borderRadius: "0px" }}
                startIcon={<SearchIcon className="actionIcon" />}
                onClick={handleSearchClick} // Trigger search functionality on button click
              >
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <CustomButton onClick={() => {
              navigate(`/app-vcoi/Vcoisitecontent/VcoiAddNewPermission`, {
                state: { V_countriesListData: V_countriesList } // Pass data in state
              })
            }} label="+ ADD NEW PERMISSION" />
          </Grid>
        </Grid>
        <Box sx={{ marginTop: "20px", overflowX: "auto", width: "100%" }}>
        <Box sx={{ minWidth: "700px" }}> {/* Prevents content shrinking */}
          <Grid
            container
            spacing={2}
            alignItems="flex-start"
            my={2}
            sx={{
              fontWeight: "bold",
              color: "gray",
            }}
          >
            <Grid item xs={5} sm={5} md={5}>
              ENTITY ADMIN GROUP
            </Grid>
            <Grid item xs={5} sm={5} md={5}>
              ENTITY
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
            </Grid>
          </Grid>
          <Divider/>

          {/* Content Section */}
          {currentItems?.length > 0 ? (
            currentItems.map((item, index) => (
              <React.Fragment key={index}>
                    <Grid container spacing={2} sx={{ alignItems: "flex-start",padding:"10px 0px"}}>
                      <Grid item xs={5} sm={5} md={5}>
                        <Typography>{item.EntityAdminGroup}</Typography>
                      </Grid>

                      {/* ENTITY */}
                      <Grid item xs={5} sm={5} md={5}>
                        {Array.isArray(item.Entities) ? (
                          item.Entities.map((group, i) => (
                            <Typography key={i}>{group.Entity}</Typography>
                          ))
                        ) : (
                          <Typography>{item.Entities}</Typography>
                        )}
                      </Grid>

                      {/* Actions - Desktop */}
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        sx={{
                          display: { xs: "none", sm: "none", md: "flex" },
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          className="actionButton"
                          variant="contained"
                          startIcon={<DeleteIcon className="actionIcon" />}
                          onClick={() => handleDelete(item)}
                        >
                          Delete
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          className="actionButton"
                          variant="contained"
                          startIcon={<EditIcon className="actionIcon" />}
                          onClick={() =>
                            navigate('/app-vcoi/Vcoisitecontent/VcoiAddNewPermission', {
                              state: { PermissionData: item },
                            })
                          }
                        >
                          Edit
                        </Button>
                      </Grid>

                      {/* Actions - Mobile */}
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        sx={{
                          display: { xs: "flex", sm: "flex", md: "none" },
                          justifyContent: "center",alignItems:"center"
                        }}
                      >
                        <DeleteIcon
                          className="actionIconResponsive"
                          onClick={() => handleDelete(item)}
                        />
                        &nbsp;&nbsp;
                        <EditIcon
                          className="actionIconResponsive"
                          onClick={() =>
                            navigate('/app-vcoi/vcoisitecontent/VcoiAddNewPermission', {
                              state: { PermissionData: item },
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                {/* Divider */}
                <Divider/>
              </React.Fragment>
            ))
          ) : (
            <>
              {(!inProgress && V_countriesList === 0 )|| V_AdminPermissionList?.length === 0 || filteredItems?.length === 0 ? (
                <Typography sx={{ margin: "20px", textAlign: "center", color: "gray", fontStyle: "italic" }}>
                  No Data Found...
                </Typography>
              ) : null}
              <hr className="customHr" />
            </>
          )}
        </Box>
        </Box>
        {currentItems?.length > 0 && <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Pagination showFirstButton showLastButton sx={{
            margin: "10px", padding: "5px", border: "1px solid #212129",
            borderRadius: "20px"
          }} count={Math.ceil(filteredItems?.length / itemsPerPage)} page={currentPage} onChange={handlePageChange} /></Box>}
      </Box>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default VcoiManageAdminPermission;
